export enum ErrorCodes {
  CREDENTIALS_INVALID = 'CREDENTIALS_INVALID',
  UNAUTHORIZED = 'UNAUTHORIZED',
  CAPTCHA_REQUIRED = 'CAPTCHA_REQUIRED',
}
